



































































































































































import { Component, Vue } from "vue-property-decorator";
import { RequestsModule } from "@/store/requests.module";
import { ParamData, Requests, RequestsDTO } from "../../lib/requests.type";
import { AuthModule } from "@/store/auth.module";
import { translate } from "@/utils";
import SignRequest from "@/components/ui/SignRequest.vue";
import SignContract from "@/components/ui/SignContract.vue";
import { ReportAction, ReportMode } from "~/services/report";
import { ReportsModule } from "@/store/reports.module";

@Component({
  components: { SignRequest, SignContract },
})
export default class Contracts extends Vue {
  formData: ParamData = new ParamData();
  expanded = [];
  dialogDelete: boolean = false;
  itemSelected: Requests = null as any;
  deleteReq(item: Requests) {
    this.dialogDelete = true;
    this.itemSelected = item;
  }

  async showContract(item: Requests) {
    const fileData = await RequestsModule.getAttachmentByCodeName({
      CCRID: item.record_id,
      CodeName: "attach_contract_signed",
    });
    const byteOffset = 0;
    const b = new Blob([
      new Uint8Array(fileData.attach_file.data, byteOffset, length),
    ]);
    const html: string = await b.text();
    const newWindow = window.open();
    newWindow?.document.write(html);
  }

  async deleteReqAction() {
    this.dialogDelete = false;
    await RequestsModule.deleteRequest({
      CRRID: this.itemSelected.record_id,
    });
    await this.loadTable();
  }

  get headers() {
    return [
      {
        text: this.$t("requests.req"),
        value: "request_date",
        sortable: false,
      },
      {
        text: this.$t("requests.number"),
        value: "request_number",
        sortable: false,
      },
      {
        text: this.$t("requests.last_action"),
        value: "last_action",
        sortable: false,
      },
      {
        text: this.$t("requests.status"),
        value: "state_type_name",
        sortable: false,
      },
      {
        text: this.$t("requests.comment"),
        value: "request_description",
        sortable: false,
      },
      {
        text: this.$t("requests.contract"),
        value: "contract_number",
        sortable: false,
      },
    ];
  }
  get loading() {
    return RequestsModule.loading;
  }
  get RequestsList() {
    return translate(RequestsModule.RequestsList);
  }
  get listLength() {
    return RequestsModule.listLength;
  }
  get listPagination() {
    return RequestsModule.listPagination;
  }
  set listPagination(val) {
    RequestsModule.setlistPagination(val);
    this.loadTable();
  }

  get user() {
    return AuthModule.user as IUser;
  }

  async loadTable() {
    if (this.user && this.user.record_id) {
      RequestsModule.setloading();
      const req: RequestsDTO = new RequestsDTO();
      req.CRID = this.user.record_id;
      req.iLimit = this.listPagination.itemsPerPage;
      req.iOffset =
        this.listPagination.itemsPerPage * (this.listPagination.page - 1);
      RequestsModule.loadRequestsList(req);
    }
  }

  async mounted() {
    await RequestsModule.loadRefRegions();
    await RequestsModule.loadBanksForRefs();
    await RequestsModule.loadOrgBranches();
    await RequestsModule.loadOrgTypes();
    await this.loadTable();
    RequestsModule.setSelectedItem(null as any);
  }

  async edit(item: Requests) {
    this.MakeAction(item, "newcontract");
  }

  async attach(item: Requests) {
    this.MakeAction(item, "attachments");
  }

  async plan(item: Requests) {
    this.MakeAction(item, "plan");
  }

  async MakeAction(item: Requests, action: string) {
    RequestsModule.setSelectedItem(item);
    this.$router.push(`/${action}/${item.record_id}`);
  }

  canPrint(item: Requests) {
    const statuses = [
      "state_considering",
      "state_approval",
      "state_abonent_signing",
      "state_contract_signed",
    ];
    return statuses.filter((x) => x === item.code_name).length > 0;
  }

  async showAccept(item: Requests) {
    await RequestsModule.getContractorRequest(item.record_id);
    Object.keys(this.formData).forEach((key) => {
      const str = key as keyof typeof ParamData;
      (this.formData as any)[str] = this.getParam(key);
    });
    await this.generate("preview", "open", item);
  }

  getParam(code_name: string): any {
    return RequestsModule.reqDetailList.find(
      (item) => item.code_name === code_name,
    )?.param_value;
  }

  getQRCodeData() {
    const obj = {
      data: `БИН:, ФИО: , ЭЦП:`,
    };
    return new URLSearchParams(obj).toString();
  }

  async generate(
    mode: ReportMode,
    action: ReportAction,
    item: Requests,
  ): Promise<unknown> {
    const signParams = {
      fio: this.user.first_boss_name,
      contract_number: item.contract_number ? item.contract_number : "0",
      roes_ru: RequestsModule.OrgBranches.find(
        (x) => x.record_id === this.formData.azhk_org_branch,
      )?.org_branch_name___ru,
      roes_kz: RequestsModule.OrgBranches.find(
        (x) => x.record_id === this.formData.azhk_org_branch,
      )?.org_branch_name___kz,
      phone_number: this.formData.as_mobile_phone,
      phone_number_media: this.formData.as_mobile_phone_multimedia,
      phone_number_messenger: this.formData.as_mobile_phone_messenger,
      mail_address: this.formData.as_post_address,
      email: this.formData.as_email,
    };
    const type = (mode === "text" ? "text" : "pdf") as ReportMode;
    return await ReportsModule.generateReport({
      action: action,
      path: "Accept.prpt",
      type: type,
      filename: this.$t("actions.accept.title") as string,
      query: {
        ...signParams,
        qrcode_data: this.getQRCodeData(),
        mode: mode,
      },
    });
  }

  async showReqPdf(item: Requests) {
    await ReportsModule.generateReport({
      action: "open",
      path: "Request.prpt",
      type: "pdf",
      filename: this.$t("actions.accept.title") as string,
      query: {
        RID: item.record_id,
      },
    });
  }
}
